import { useContext } from "react"
import { OrgContext } from "src/context/OrgContext"

export const useOrg = () => useContext(OrgContext)
